import Vue from 'vue'
import Router from 'vue-router'

import Index from './components/index/index'


// 公共区域


// 首页
import Home from './views/home.vue'

// 纪念馆列表
const Memorial  =(resolve) =>{
    import('./views/memorial/list').then((module)=>{
        resolve(module)
    })
}

//纪念馆详情
const MemorialDetail  =(resolve) =>{
    import('./views/memorial/detail').then((module)=>{
        resolve(module)
    })
}

//个人中心
const PersonCenter  =(resolve) =>{
    import('./views/person-center/main').then((module)=>{
        resolve(module)
    })
}

// 服务
import Service from './views/services.vue'

// 新闻中心
import News from './views/news/list.vue'
import NewsDetail from './views/news/detail.vue'

// 预约
import Order from './views/order/order.vue'

//预约详情
import orderInfo from './views/order/info.vue'

// 联系我们
import About from './views/about.vue'

Vue.use(Router);

export default new Router({
    mode:'history',
    routes: [
        {
            path:'/',
            redirect:'/Home'
        },
        {
            path: '/Home',
            component: Index,
            alias:'/index',
            children: [
                {
                    path: '/',
                    name: 'home',
                    components: {
                        content: Home,
                    }
                }
            ]
        },
        {
            path: '/services',
            component: Index,
            children: [
                {
                    path: '/',
                    name: 'service',
                    components: {
                        content: Service,
                    }
                }
            ]
        },
        {
            path: '/memorial',
            component: Index,
            children: [
                {
                    path: '/',
                    name: 'memorial',
                    components: {
                        content: Memorial,
                    }
                }
            ]
        },
        {
            path: '/memorialDetail/:id',
            component: Index,
            children: [
                {
                    path: '/',
                    name: 'memorialDetail',
                    components: {
                        content: MemorialDetail,
                    }
                }
            ]
        },
        {
            path: '/news',
            component: Index,
            children: [
                {
                    path: '/',
                    name: 'news',
                    components: {
                        content: News,
                    }
                }
            ]
        },
        {
            path: '/newsDetail',
            component: Index,
            children: [
                {
                    path: '/',
                    name: 'newsDetail',
                    components: {
                        content: NewsDetail,
                    }
                }
            ]
        },
        {
            path: '/about',
            component: Index,
            children: [
                {
                    path: '/',
                    name: 'about',
                    components: {
                        content: About,
                    }
                }
            ]
        },
        {
            path: '/personCenter',
            component: Index,
            children: [
                {
                    path: '/',
                    name: 'personCenter',
                    components: {
                        content: PersonCenter,
                    }
                }
            ]
        },
        {
            path: '/order/order',
            component: Index,
            children: [
                {
                    path: '/',
                    name: 'order',
                    components: {
                        content: Order,
                    }
                }
            ]
        },
        {
            path: '/order/list',
            component: Index,
            children: [
                // {
                //     path: '/',
                //     name: 'orderList',
                //     components: {
                //         content: OrderList,
                //     }
                // }
            ]
        },{
            path: '/order/info/',
            component: Index,
            children: [
                {
                    path: '/',
                    name: 'orderInfo',
                    components: {
                        content: orderInfo,
                    }
                }
            ]
        }
    ]
})
